import type {ScoringContext} from "../model/ScoringContext.ts";
import type {JobHolder} from "../../../metl-models/jobs/JobType.ts";
import {scorerPythonComponents} from "./PythonLibraryDownweight.ts";
import {scorerTransformationJobUpweight} from "./TransformationJobUpweight.ts";
import {scorerMissingOrReworkComponents} from "./MissingComponents.ts";
import type {ScoreResult} from "../model/ScoreResult.ts";

const scorers = [
    scorerPythonComponents,
    scorerTransformationJobUpweight,
    scorerMissingOrReworkComponents
]

export function scoreJob(ctx: ScoringContext, job: JobHolder) {
    const scores = scorers.map(scorer => scorer(job.job))

    const resultantScore = scores.reduce<ScoreResult<JobHolder>>((acc, value) => {
        if(value) {
            acc.score += value.score
            acc.description?.push(...(value.description ?? []))
            acc.children?.push(value)
        }
        return acc
    }, {
        scoredObject: job,
        scorerId: "job-scorer",
        children: [],
        description: [],
        score: 0
    })

    ctx.jobs[job.name] = resultantScore

}